let info = {
    logo: 'http://mayi-newshop.oss-cn-shanghai.aliyuncs.com/public/png/eab963a6-b882-4471-8762-a1669e297909.png',
    name: '道可智库',
    title: '都测企业CT系统',
    copyright: 'Copyright © 2017-2023 道可智库 · 版权所有 京ICP备18058190号'
}
export default info